<template>
    <!-- Screenshots Section Start -->
    <section id="screenshot" class="screenshot padding-top-bottom">
      <div class="screenshot-decor">
        <div class="screenshot-circle1"><img :src='"../assets/images/feature-circle-two.png"' alt="feature-circle-two"></div>
        <div class="screenshot-circle2"><img :src='"../assets/images/feature-circle.png"' alt="feature-circle"></div>
        <div class="screenshot-circle3"><img :src='"../assets/images/main-banner1.png"' alt="feature-circle-three"></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 ">
            <div class="screenshot-contain">
              <img class="mobile-light-left" :src='"../assets/images/light.png"' alt="light">
              <img class="mob-mocup img-fluid" :src='"../assets/images/echodot.png"' alt="screenshot-mob">
              <img class="mobile-light-right" :src='"../assets/images/light-right.png"' alt="light-right">
              <carousel :class='"screenshot-carousel"'
                        :loop=true
                        :margin=30
                        :items=5
                        :center=true
                        :nav=false
                        :dots=false
                        :dotsEach=false
                        :autoplay=true
                        :responsive="{0:{items:2,nav:false},767:{items:2,nav:false},768:{items:3,nav:false},992:{items:4,nav:false},1200:{items:5,nav:false},1200:{items:5,nav:false}}"
                        >
                
                <div :key="skill.name" class="screenshot-item" v-for="skill in skillData">
                    <img :src='skill.previewUrl' alt="app">
                    <div class="speech-bubble"> "Alexa, open {{skill.name}}" </div>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Screenshots Section End -->
</template>
<script>
import carousel from 'v-owl-carousel'
export default {
  name:'Screenshot',
  components: {'carousel': carousel},
  data() {
      return {
        skillData: [
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51iCkp6foPL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Word Wiz",
                link: "https://www.amazon.com/dp/B07KX27GSV"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51cCnBibBtL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Christmas Escape",
                link: "https://www.amazon.com/dp/B07MGKGV8Z"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61U9MHAcWtL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Angel Investor",
                link: "https://www.amazon.com/dp/B07GBLHKVR/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/71VTgiEEI0L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Escape the Airplane",
                link: "https://www.amazon.com/dp/B07CMB6DZQ/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61XeI1DX8lL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Escape the Room",
                link: "https://www.amazon.com/dp/B075J914W2/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51ncTQvNz9L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Word Play",
                link: "https://www.amazon.com/dp/B0796331D5"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/71ZraVnX4sL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Five Minute Pushups",
                link: "https://www.amazon.com/dp/B078Z5QMH7"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/71-jXu-gGDL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Five Minute Workout",
                link: "https://www.amazon.com/dp/B0781CTG58/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61qz+mY7cJL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Good Night",
                link: "https://www.amazon.com/dp/B01N03FUSI/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51kzBz6s3FL._AC_US327_FMwebp_QL65_.png",
                testimonials: [],
                name: "Storm Sounds",
                link: "https://www.amazon.com/dp/B078561KVS/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51ltzzmUGTL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Mindful Meditation",
                link: "https://www.amazon.com/dp/B0784GXF2M/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51MIxnwQRoL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Rejuvenating Sounds",
                link: "https://www.amazon.com/dp/B077X9VGH6/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51lKl0IF4RL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Healing Sounds",
                link: "https://www.amazon.com/dp/B077WKC8M2/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/5168UVZE8PL.png",
                testimonials: [],
                name: "Guitar Backing Tracks",
                link: "https://www.amazon.com/dp/B078P3XYC8/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51M92skgvhL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Rain Sounds",
                link: "https://www.amazon.com/dp/B077WJNSW7/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/717Vee8htuL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "White Noise",
                link: "https://www.amazon.com/dp/B077L52SL8/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51Gn9mJaU5L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "One Minute Meditation",
                link: "https://www.amazon.com/dp/B078599KWY/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51U24ryxahL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Island Sounds",
                link: "https://www.amazon.com/dp/B077WMHBSP/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/71SG3-V-5VL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Fast Weather",
                link: "https://www.amazon.com/dp/B074XH8TWG/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61jbjq0wROL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Shut Up",
                link: "https://www.amazon.com/dp/B074YMD78K/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51awa-VvvmL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Ocean Sounds",
                link: "https://www.amazon.com/dp/B077TF29FB/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51ZvlfOGE0L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Campfire Sounds",
                link: "https://www.amazon.com/dp/B077VMXHVH/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61qIe7glg+L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Jungle Sounds",
                link: "https://www.amazon.com/dp/B077WFQPD5/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/515d1NpW03L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Forest Sounds",
                link: "https://www.amazon.com/dp/B077VGQF5D/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51jl3KT1f+L._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Waterfall Sounds",
                link: "https://www.amazon.com/dp/B077V928WF/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/51CrMWX4k9L.png",
                testimonials: [],
                name: "Fireplace Sounds",
                link: "https://www.amazon.com/dp/B078NPLZ31/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61jD6ntHIWL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Random Workout",
                link: "https://www.amazon.com/dp/B074XMFJQH/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/61xLxFcgPwL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Worldwide Surf Report",
                link: "https://www.amazon.com/dp/B01N6A068E/"
            },
            {
                previewUrl: "https://images-na.ssl-images-amazon.com/images/I/611z0EWWVRL._SL210_QL95_BG0,0,0,0_FMpng_.png",
                testimonials: [],
                name: "Pushup Challenge",
                link: "https://www.amazon.com/dp/B074YCDWH9/"
            }
        ]
      }
  }
}
</script>

<style>
.owl-stage-outer {
    padding-top: 200px;
    margin-top: -200px;
}
</style>
<style scoped>


.owl-item.center .speech-bubble {
    opacity: 1;
    transition: opacity .6s ease-in-out;
}
.owl-item .speech-bubble {
    box-shadow: 2px 2px 3px 0px rgba(0,0,0,0.5);
    text-align: center;
    transition: opacity .6s ease-in-out;
    opacity: 0;
    position: absolute;
    background: white;
    top: -130px;
    overflow: visible;
    padding: 25px;
    border-radius: 10px;
    font-family: Poppins;
    font-style: italic;
    color: #777777;
}
.owl-item .speech-bubble:after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 25%;
	width: 0;
	height: 0;
	border: 34px solid transparent;
	border-top-color: white;;
	border-bottom: 0;
	border-left: 0;
	margin-left: -17px;
	margin-bottom: -34px;
}
.owl-item {
    overflow: visible;
}

</style>


// WEBPACK FOOTER //
// src/components/screenshots.vue